import React from 'react';

export const ImagePreview = ({
  file,
  className = '',
  alt = 'Image Preview',
}) => (
  <figure className={`image-preview--wrapper ${className}`}>
    <img src={URL.createObjectURL(file)} alt={alt} />
  </figure>
);



// WEBPACK FOOTER //
// ./src/common/ImagePreview.js